import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useApp } from "../../hooks/AppProvider";

const GLITCH_CHARS = '`¡™£¢∞§¶•ªº–≠åß∂ƒ©˙∆˚¬…æ≈ç√∫˜µ≤≥÷/?<>/azertyuiopmlkjhgfdsqsqwxcvbn'.split('');

function GlitchedLetter({ char, revealed }) {

    const [letter, setLetter] = useState("");

    useEffect(() => {
        let interval = setInterval(() => {            
            if(revealed) {
                setLetter(char)
                clearInterval(interval);
                return;
            }

            setLetter(GLITCH_CHARS[Math.floor(Math.random() * GLITCH_CHARS.length)]);
        }, 20);

        return () => clearInterval(interval);
    }, [revealed]);

    return (
        <div className="glitched-letter">
            <span>{letter}</span>
        </div>
    );
}

function GlitchedText({ maxLength, text, reveal, revealDuration, onTerminateReveal }) {

    const [letters, setLetters] = useState([]);
    const [revealed, setReveled] = useState([]);

    useEffect(() => {
        const array = text.split("");
        
        const concatArray = Array(maxLength-text.length >= 0 ? maxLength-text.length : 0);
        concatArray.fill("");
        
        setLetters(array.concat(concatArray));
    }, [text, maxLength]);

    useEffect(() => {
        if(!reveal) {
            return;
        }
        
        const indexs = [];
        for(let i = 0; i < maxLength; i++)
            indexs.push(i)
        
        indexs.sort(() => Math.random() - 0.5);
        
        let interval = setInterval(() => {
            
            if(indexs.length === 0) {
                clearInterval(interval);
                onTerminateReveal();
                return;
            }

            const revealedIndex = indexs.pop();
            
            setReveled(e => {return [...e, revealedIndex]});
        }, revealDuration*1000 / maxLength);

        return () => clearInterval(interval);
    }, [reveal, maxLength]);
    
    return (
        <div className="glitched-letters-container">           
            {revealed && letters.map((letter, index) => {
                
            return    <GlitchedLetter char={letter} key={index} revealed={revealed.includes(index)} />
            })}
        </div>
    )
}

function BehaviorPodium({ podium, maxTextLength, revealDuration }) {

    const navigate = useNavigate();

    const [thirdReveal, setThirdReveal] = useState(false);
    const [secondReveal, setSecondReveal] = useState(false);
    const [firstReveal, setFirstReveal] = useState(false);

    const [inReveal, setInReveal] = useState(false);

    useEffect(() => {
        if(podium.length >= 3) {
            setThirdReveal(podium[2].length===0);
            setSecondReveal(podium[1].length===0);
            setFirstReveal(podium[0].length===0);
        }
    }, [podium]);

    const onClickRevealThird = () => {
        setThirdReveal(true);
        setInReveal(true);
    }

    const onClickRevealSecond = () => {
        setSecondReveal(true);
        setInReveal(true);
    }

    const onClickRevealFirst = () => {
        setFirstReveal(true);
        setInReveal(true);
    }

    const onTerminateReveal = () => {
        setInReveal(false);
    }

    const onClickTerminate = () => {
        navigate("/app/behavior/groups");
    }

    return (
        <div className="podium-container">
            <div className="podium">
                <div className="podium-column">
                    <div className="podium-up">
                        {podium.length >= 3 && podium[1].map((val, index) => (
                            <GlitchedText key={2 + ":" + index} maxLength={maxTextLength} text={val.student_name} reveal={secondReveal} revealDuration={revealDuration} onTerminateReveal={onTerminateReveal}/>
                        ))}
                    </div>
                    <div className="podium-stair podium-2">
                        <span className="podium-label">2</span>
                    </div>
                </div>
                <div className="podium-column">
                    <div className="podium-up">
                        {podium.length >= 3 && podium[0].map((val, index) => (
                            <GlitchedText key={1 + ":" + index} maxLength={maxTextLength} text={val.student_name} reveal={firstReveal} revealDuration={revealDuration} onTerminateReveal={onTerminateReveal}/>
                        ))}
                    </div>
                    <div className="podium-stair podium-1">
                        <span className="podium-label">1</span>
                    </div>
                </div>
                <div className="podium-column">
                    <div className="podium-up">
                        {podium.length >= 3 && podium[2].map((val, index) => (
                            <GlitchedText key={3 + ":" + index} maxLength={maxTextLength} text={val.student_name} reveal={thirdReveal} revealDuration={revealDuration} onTerminateReveal={onTerminateReveal}/>
                        ))}
                    </div>
                    <div className="podium-stair podium-3">
                        <span className="podium-label">3</span>
                    </div>
                </div>
            </div>
            <div className="podium-bottom">
                {!thirdReveal && !inReveal && <button onClick={onClickRevealThird}>Révéler la 3<sup>e</sup> place</button>}
                {!secondReveal && thirdReveal && !inReveal && <button onClick={onClickRevealSecond}>Révéler la 2<sup>de</sup> place</button>}
                {!firstReveal && thirdReveal && secondReveal && !inReveal && <button onClick={onClickRevealFirst}>Révéler la 1<sup>re</sup> place</button>}
                {firstReveal && thirdReveal && secondReveal && !inReveal && <button onClick={onClickTerminate}>Terminer</button>}
            </div>
        </div>
    )
}

function BehaviorTermStudentsAnimation() {
    const app = useApp();

    const params = useParams();

    const [termId, setTermId] = useState(params.termId);
    const [term, setTerm] = useState({});
    const [podium, setPodium] = useState([]);
    const [maximumTextLength, setMaximumTextLength] = useState(0);


    useEffect(() => {
        app.sendGet("/behavior/term/" + termId, data => {
            if(data.success === false) {
                alert("Une erreur s'est produite: [32]");
                app.navigate("/app/behavior/groups");
                return;
            }
            setTerm(data);
        })

        app.sendPost("/behavior/term/rank/students", {id: termId}, data => {
            if(data.success === false) {
                app.navigate("/app/behavior/groups");
                return;
            }

            if(data.length === 0) {
                alert("Vous n'avez pas d'élèves");
                app.navigate("/app/behavior/groups");
                return;
            }

            const pod = [[], [], []];
            const sortedData = data.sort((a, b) => b.total_amount - a.total_amount);
            const podiumPoints = [];
            for(let student of data) {
                if(!podiumPoints.includes(student.total_amount)) {
                    if(podiumPoints.length === 3)
                        break;

                    podiumPoints.push(student.total_amount);
                }
                pod[podiumPoints.length-1].push(student);
            }
            pod[0] = pod[0].sort((a, b) => b.student_name.length - a.student_name.length)
            pod[1] = pod[1].sort((a, b) => b.student_name.length - a.student_name.length)
            pod[2] = pod[2].sort((a, b) => b.student_name.length - a.student_name.length)
            setPodium(pod);            
            setMaximumTextLength(data.map(val => val.student_name.length).sort((a, b) => b - a)[0]);
        });
    }, []);

    return (
        <div>
            <header className="header">
                <span className="header-title">Podium élèves de la période: {(term?.name ?? "Période inconnue")}</span>
            </header>
            <div className="main-container">
                <BehaviorPodium maxTextLength={maximumTextLength} podium={podium} revealDuration={3} />
            </div>
        </div>
    );
}

export default BehaviorTermStudentsAnimation;